import './simple-linear-carousel.scss';
import React           from 'react';
import { Link }        from 'react-router-dom';

function SimpleLinearCarousel ({ data, baseUrl }) {
	const genre_name = (genre_name) => {
		localStorage.setItem('gname', genre_name);
	}

	return (
		<div className="simple-linear-carousel">
			<div className="genres">
				{data.map((content, index) => {
					if (index < 15) {
						return (
							<Link key={index}
								  onClick={() => genre_name(content.farsiTitle)}
								  to={content?.deepLink + `/movies`}
								  className="item">
								<span className="box-title">{content.farsiTitle}</span>
							</Link>
						);
					}
					return null;
				})}
			</div>
		</div>
	);
}

export default SimpleLinearCarousel;
